var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "save-success-modal",
      attrs: {
        visible: _vm.visible,
        footer: null,
        closable: false,
        "mask-closable": false,
        width: 480,
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "modal-content" },
        [
          _c(
            "div",
            { staticClass: "success-icon" },
            [_c("a-icon", { attrs: { type: "check" } })],
            1
          ),
          _c("h2", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.$t("CampaignPublishedSuccessfully"))),
          ]),
          _c("p", { staticClass: "modal-subtitle" }, [
            _c("strong", [
              _vm._v('"' + _vm._s(_vm.queterInfo.campaign_name) + '"'),
            ]),
            _vm._v(" " + _vm._s(_vm.$t("AddedToExecutionQueue")) + " "),
          ]),
          _c("div", { staticClass: "forecast-section" }, [
            _c(
              "h3",
              { staticClass: "forecast-title" },
              [
                _c("a-icon", { attrs: { type: "bar-chart" } }),
                _vm._v(" " + _vm._s(_vm.$t("ExecutionForecast")) + " "),
              ],
              1
            ),
            _vm.queterInfo.campaign_list
              ? _c("div", { staticClass: "forecast-item" }, [
                  _c("span", { staticClass: "forecast-label" }, [
                    _vm._v(_vm._s(_vm.$t("QueuePosition"))),
                  ]),
                  _c("span", { staticClass: "forecast-value" }, [
                    _vm._v(
                      "No. " +
                        _vm._s(_vm.getPos + 1) +
                        " (" +
                        _vm._s(_vm.$t("outOf")) +
                        " " +
                        _vm._s(_vm.queterInfo.campaign_list.length) +
                        " " +
                        _vm._s(_vm.$t("Campaigns")) +
                        ")"
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("div", { staticClass: "forecast-item" }, [
              _c("span", { staticClass: "forecast-label" }, [
                _vm._v(_vm._s(_vm.$t("AllocationMode"))),
              ]),
              _c("span", { staticClass: "forecast-value" }, [
                _vm._v(_vm._s(_vm.allocationModeText)),
              ]),
            ]),
            _c("div", { staticClass: "forecast-item" }, [
              _c("span", { staticClass: "forecast-label" }, [
                _vm._v(_vm._s(_vm.$t("DailyLimit"))),
              ]),
              _vm.queterInfo.linkedin_info
                ? _c("span", { staticClass: "forecast-value highlight" }, [
                    _vm._v(
                      _vm._s(_vm.queterInfo.linkedin_info.request_limit) +
                        " " +
                        _vm._s(_vm.$t("requestsPerDay"))
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("div", { staticClass: "queue-section" }, [
            _c("h3", { staticClass: "queue-title" }, [
              _vm._v(_vm._s(_vm.$t("CurrentExecutionQueue")) + ":"),
            ]),
            _vm.queterInfo.campaign_list
              ? _c(
                  "div",
                  { staticClass: "queue-list" },
                  _vm._l(
                    _vm.queterInfo.campaign_list,
                    function (campaign, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "queue-item",
                          class: {
                            current: _vm.getPos == index ? true : false,
                          },
                        },
                        [
                          _c("div", { staticClass: "queue-left" }, [
                            _c(
                              "span",
                              {
                                staticClass: "queue-number",
                                class: {
                                  top: index === 0,
                                  second: index === 1,
                                  third: index === 2,
                                },
                              },
                              [_vm._v(_vm._s(index + 1))]
                            ),
                            _c("span", { staticClass: "campaign-name" }, [
                              _vm._v(_vm._s(campaign.campaign_name)),
                            ]),
                            _vm.getPos == index
                              ? _c("span", { staticClass: "current-badge" }, [
                                  _vm._v("⭐"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm.queterInfo.linkedin_info.allocation_mode == 1
                            ? _c(
                                "div",
                                { staticClass: "queue-right" },
                                [
                                  campaign.today_plan_kind == "needed"
                                    ? _c(
                                        "span",
                                        { staticClass: "needed-badge" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(campaign.today_send_count)
                                            ),
                                          ]),
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("needed"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  campaign.today_plan_kind == "none"
                                    ? _c("span", [_vm._v("--")])
                                    : _vm._e(),
                                  campaign.today_plan_kind == "today"
                                    ? _c(
                                        "span",
                                        { staticClass: "today-badge" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(campaign.today_send_count)
                                            ),
                                          ]),
                                          _vm._v(" " + _vm._s(_vm.$t("today"))),
                                        ]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 3
                                    ? _c(
                                        "span",
                                        { staticClass: "status-badge done" },
                                        [_vm._v(_vm._s(_vm.$t("done")))]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "status-badge in-progress",
                                        },
                                        [_vm._v(_vm._s(_vm.$t("inProgress")))]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 2 ||
                                  campaign.send_status == 4
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "status-badge waiting",
                                          },
                                          [_vm._v(_vm._s(_vm.$t("waiting")))]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.queterInfo.linkedin_info.allocation_mode == 2
                            ? _c(
                                "div",
                                { staticClass: "queue-right" },
                                [
                                  campaign.send_status !== 3
                                    ? _c(
                                        "span",
                                        { staticClass: "needed-badge" },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(campaign.today_send_count)
                                            ),
                                          ]),
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("needed"))
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 3
                                    ? _c(
                                        "span",
                                        { staticClass: "status-badge done" },
                                        [_vm._v(_vm._s(_vm.$t("done")))]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "status-badge in-progress",
                                        },
                                        [_vm._v(_vm._s(_vm.$t("inProgress")))]
                                      )
                                    : _vm._e(),
                                  campaign.send_status == 2
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "status-badge waiting",
                                          },
                                          [_vm._v(_vm._s(_vm.$t("waiting")))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  campaign.send_status == 4
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "status-badge waiting",
                                          },
                                          [_vm._v(_vm._s(_vm.$t("waiting")))]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
          ]),
          _vm.queterInfo.linkedin_info &&
          _vm.queterInfo.linkedin_info.allocation_mode == 1
            ? _c("div", { staticClass: "sequential-notice" }, [
                _c(
                  "div",
                  { staticClass: "notice-header" },
                  [
                    _c("a-icon", {
                      staticClass: "notice-icon",
                      attrs: { type: "exclamation-circle", theme: "filled" },
                    }),
                    _c("span", { staticClass: "notice-title" }, [
                      _vm._v(_vm._s(_vm.$t("SequentialExecutionNotice"))),
                    ]),
                  ],
                  1
                ),
                _c("p", { staticClass: "notice-content" }, [
                  _vm._v(
                    " " + _vm._s(_vm.$t("SequentialNoticeModalContent")) + " "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "notice-tip" },
                  [
                    _c("a-icon", { attrs: { type: "bulb" } }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("SequentialNoticeModalTip"))),
                    ]),
                  ],
                  1
                ),
              ])
            : _c("div", { staticClass: "equal-notice" }, [
                _c("span", { staticClass: "notice-icon" }, [_vm._v(" 💡")]),
                _c("div", { staticClass: "right-col" }, [
                  _c("div", { staticClass: "notice-header" }, [
                    _c("span", { staticClass: "notice-title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("EqualExecutionNotice"))),
                    ]),
                  ]),
                  _c("p", { staticClass: "notice-content" }, [
                    _vm._v(" " + _vm._s(_vm.$t("EqualNoticeContent")) + " "),
                  ]),
                ]),
              ]),
          _c(
            "a-button",
            {
              staticClass: "action-btn",
              attrs: { type: "primary" },
              on: { click: _vm.handleManage },
            },
            [_vm._v(" " + _vm._s(_vm.$t("GoToManageCampaignList")) + " ")]
          ),
          _vm.queterInfo.allocation_mode == 1
            ? _c("p", { staticClass: "footer-note" }, [
                _vm._v(" " + _vm._s(_vm.$t("ModifySequenceNote")) + " "),
              ])
            : _c("p", { staticClass: "footer-note" }, [
                _vm._v(" " + _vm._s(_vm.$t("ModifyAllocationNote")) + " "),
              ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }